import React from "react";

const ArrowDownSmall = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.5 10.563L12.53 16.28c-.187.157-.375.219-.531.219a.848.848 0 01-.531-.188l-6-5.75A.746.746 0 015.437 9.5.746.746 0 016.5 9.469l5.5 5.25 5.469-5.25a.746.746 0 011.062.031.746.746 0 01-.031 1.063z"
      fill="#8B8B8B"
    />
  </svg>
);

export default ArrowDownSmall;
